/**
 * Format number in Greek locale with 2 decimal places
 */
export function formatNumber(num: number | null | undefined): string {
  if (num === null || num === undefined || isNaN(num)) return '--';
  return new Intl.NumberFormat('el-GR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num / 1000);
}

/**
 * Format ISO date string to readable time format
 */
export function formatTime(iso: string | null | undefined): string {
  if (!iso || iso === '--') return '--';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '--';
  
  const pad = (n: number) => n.toString().padStart(2, '0');
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  
  return `${pad(d.getHours())}:${pad(d.getMinutes())}  ${days[d.getDay()]} ${pad(d.getDate())} ${months[d.getMonth()]} ${d.getFullYear()}`;
}

/**
 * Generate signal bars HTML based on CSQ value
 */
export function generateSignalBars(csq: number | null | undefined): string {
  // 0-31, 31 is best, 0 is worst, null/undefined is gray
  const val = csq !== undefined && csq !== null ? parseInt(String(csq)) : NaN;
  let bars = '';
  
  for (let i = 1; i <= 5; i++) {
    const threshold = 2 + (i - 1) * 6; // 2,8,14,20,26
    bars += `<span class="signal-bar${val >= threshold ? ' active' : ''}" style="height:${5 + i * 3}px"></span>`;
  }
  
  return `<span class="signal-bars">${bars}</span>` + (isNaN(val) ? '--' : `<span style="font-size:0.9em;color:#666;">${val}</span>`);
} 